import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-archive-class-support-article',
    template: `
        <ng-container i18n="@@support.articles.archiveClass">
            <p>Archiving is a safe way to hide a class from the overview, without actually deleting it. It is a good idea, for example, to archive all classes at the end of the school year, so that the new school year can be started with a clean slate.</p>
            <p>Archiving a class does not delete anything. So you can still retrieve the results of students if necessary. Students of the archived class can also still log in as long as their license is active.</p>

            <h2>Archiving</h2>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>
                        Click on the three dots on the right side of the class.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/archiveClassBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Archive</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <span>
                        A warning appears. Click the <strong>"Archive"</strong> button to confirm.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/archiveClass.png" />
                    </span>
                </li>
            </ol>

            <h2>View archived classes</h2>
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/classes">Classes Overview</a>.</span>
                </li>
                <li>
                    <span>
                        Click <strong>"Show archived"</strong>
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/archiveClassBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        The archived classes are now included in the list. You can recognize archived classes by the label "Archived".
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/archivedClassExample.png" />
                    </span>
                </li>
            </ol>

            <h2>Unarchive</h2>
            <ol>
                <li>
                    <span>Follow the steps described above under "View archived classes".</span>
                </li>
                <li>
                    <span>Find the desired class in the list.</span>
                </li>
                <li>
                    <span>
                        Click on the three dots on the right side of the class.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/unarchiveClassBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>"Unarchive"</strong> in the menu that opens.
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class ArchiveClassSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
